import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { CircularProgress, capitalize } from "@mui/material";
import type { TestChatState } from "../types/test-chat";
import { StatusChip, type StatusEntry } from "./ui/status-chip";

const STATUS_MAP: Partial<Record<TestChatState, StatusEntry>> = {
  thinking: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "info",
  },
  running: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "primary",
  },
  error: { icon: <ErrorIcon sx={{ fontSize: 12 }} />, color: "error" },
  waiting: {
    icon: <QuestionMarkIcon sx={{ fontSize: 12 }} />,
    color: "warning",
  },
  done: { icon: <DoneAllIcon sx={{ fontSize: 12 }} />, color: "success" },
};

type Props = {
  state: TestChatState;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
};

export const TestChatStateChip: React.FC<Props> = ({
  state,
  variant = "filled",
  size = "medium",
}) => (
  <StatusChip
    status={state}
    statusMap={STATUS_MAP}
    formatLabel={capitalize}
    variant={variant}
    size={size}
  />
);
